import { ArticleFaceType } from "../dtos/articleFaceType";

export interface IArticleFaceType {
	text: string;
	value: ArticleFaceType;
}

const values: IArticleFaceType[] = [
	{
		text: "Unterseite",
		value: ArticleFaceType.Back,
	},
	{
		text: "Oberseite",
		value: ArticleFaceType.Visible,
	},
	{
		text: "Beide Seiten",
		value: ArticleFaceType.Both,
	},
];

export default values;
